module.exports = __webpack_public_path__ + "media/images/emblems/La_Neuveville-coat_of_arms-394a89af656ff8a12e9dea53c498ebc6.svg";